module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('nav', {
    staticClass: "navbar navbar-default navbar-fixed-top"
  }, [_c('div', {
    attrs: {
      "id": "redbar"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "collapse navbar-collapse navbar-right",
    attrs: {
      "id": "menu"
    }
  }, [_c('ul', {
    staticClass: "nav navbar-nav navbar-right text-uppercase"
  }, _vm._l((_vm.menu), function(m, i) {
    return _c('li', {
      attrs: {
        "id": i
      },
      on: {
        "click": function($event) {
          _vm.changeActive(i)
        }
      }
    }, [_c('a', {
      attrs: {
        "href": '#' + m
      },
      on: {
        "click": function($event) {
          _vm.smoothScroll($event)
        }
      }
    }, [_vm._v(_vm._s(m))])])
  }))])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "navbar-header"
  }, [_c('button', {
    staticClass: "navbar-toggle collapsed",
    attrs: {
      "type": "button",
      "data-toggle": "collapse",
      "data-target": "#menu",
      "aria-expanded": "false"
    }
  }, [_c('span', {
    staticClass: "sr-only"
  }, [_vm._v("Toggle navigation")]), _vm._v(" "), _c('span', {
    staticClass: "icon-bar"
  }), _vm._v(" "), _c('span', {
    staticClass: "icon-bar"
  }), _vm._v(" "), _c('span', {
    staticClass: "icon-bar"
  })]), _vm._v(" "), _c('a', {
    staticClass: "navbar-brand",
    attrs: {
      "href": "#"
    }
  }, [_c('img', {
    attrs: {
      "src": require("imgs/logo.png"),
      "alt": ""
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a50949fc"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Header.vue
// module id = 83
// module chunks = 0